export default "__VITE_ASSET__exdmgoLo__"